export default __webpack_public_path__ + "static/media/TK.65e54fd2.svg";